import React, { useCallback, useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../stores/Stores";
import Loader from "../../shared/loader/Loader";
import { TranslationContext } from "./Translation";
import pl from "../../shared/messages/pl";
import cs from "../messages/cs";
import sk from "../messages/sk";
import { LanguageVersion } from "../../shared/types/LanguageVersion";
import styles from "./translationProvider.module.scss";

const TranslationProvider: React.FC<React.PropsWithChildren> = observer(({ children }) => {
    const { userStore } = useStore();

    const [shouldRenderChildren, setShouldRenderChildren] = useState(false);

    const loadData = useCallback(async () => {
        setShouldRenderChildren(false);
        await userStore.loadBusinessLines();
        setShouldRenderChildren(true);
    }, []);

    const mapLanguageVersionToTranslationFile = (languageVersion: LanguageVersion) => {
        switch (languageVersion) {
            case LanguageVersion.Czech:
                return cs;
            case LanguageVersion.Slovakian:
                return sk;
            default:
                return pl;
        }
    };

    useEffect(() => {
        loadData();
    }, [loadData]);

    return !shouldRenderChildren ? (
        <Loader additionalClassName={styles.loaderWrapper} />
    ) : (
        <TranslationContext.Provider value={mapLanguageVersionToTranslationFile(userStore.languageVersion)}>
            {children}
        </TranslationContext.Provider>
    );
});

export default TranslationProvider;
